module.exports = __webpack_public_path__ + "img/slide4-content.23b333fd.png";